import React from "react";
import "./App.css";
import { Route, Routes, Navigate } from "react-router-dom";
import PrivateRoute from "./modules/Auth/PrivateRoute";
import ProtectedRoute from "./modules/Auth/ProtectedRoute";
import CheckAuth from "./modules/Auth/authCheck";
import history from "./modules/Navigation";
import Login from "./pages/login/login";
import Home from "./pages/backOffice/home/home";
import Summary from "./pages/backOffice/summary/summary";
import ReleaseNotes from "./components/releaseNote/ReleaseNotes";

// CheckAuth();
const App = () => {
  return (
    <>
      <Routes>
        {/* <Route  element={<ProtectedRoute />}>
        <Route exact path="/new-job" element={< NewJob/>}/>
        <Route exact path="/my-job" element={< MyJob/>}/>
        <Route exact path="/profile" element={<UserProfile />}/>
      </Route>
       */}

        <Route element={<PrivateRoute />}>
          <Route exact path="/home/*" element={<Home />} />
          <Route exact path="/summary" element={<Summary />} />
        </Route>

        <Route exact path="/" element={<Login />} />

        <Route exact path="/release-note" element={<ReleaseNotes />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

export default App;
